// import api from "../../../../../api";
// import React from "react";
// import values from "../../../../../values";
import React, { useContext, useState } from "react";
import { TModal } from "../../../../../types/common.type";
import { useQuery } from "react-query";
import values from "../../../../../values";
import api from "../../../../../api";
import Context from "../../../../../context";
import { IFindCompanyFactor } from "../../../../../types/company.interface";
import CompanyFactorScreen from "../";

// import {useQuery} from "react-query";
// import {DebtContext} from "../../../../../context";

// type TModal = "SHOW" | "NONE" | "SETUP_ORDER";

const CompanyFactorsContainer = () => {
  // ** ==============================================================================================================
  // **                                         Values Validations
  // ** ==============================================================================================================
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [selectedCompanyFactor, setSelectedCompanyFactor] = useState<any>();

  // !! ==============================================================================================================
  // !!                                           Start API Call
  // !! ==============================================================================================================

  const { userInfo } = useContext(Context.UserScreen);

  const [requestCompanyFactor, setRequestRequestCompanyFactor] =
    React.useState<IFindCompanyFactor>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      companyId: userInfo?._id,
    });

  const getAllCompanyFactor = useQuery(
    [values.useQueryKeys.getAllCompanyFactor, requestCompanyFactor, userInfo],
    () =>
      api.post.company.findCompanyFactor({
        ...requestCompanyFactor,
        companyId: userInfo?._id,
      })
  );

  // async function onPayCompanyFactor(formData: IPayCompanyFactorToDriver) {
  //   console.log(formData);
  //   setIsLoading(true);
  //   const result = await api.post.company.payDriverCompanyFactor(formData);
  //   if (result) {
  //     utils.successHandler(Number(result?.CODE));
  //     getAllCompanyFactor.refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }

  // !! ==============================================================================================================
  // !!                                            End API Call
  // !! ==============================================================================================================

  // ?? ==============================================================================================================
  // ??                                            JSX Container
  // ?? ==============================================================================================================

  return (
    <Context.CompanyFactorScreen.Provider
      value={{
        isLoading,
        showModal,
        setIsLoading,
        setShowModal,
        requestCompanyFactor,
        setRequestRequestCompanyFactor,
        selectedCompanyFactor,
        setSelectedCompanyFactor,
      }}
    >
      <CompanyFactorScreen rqData={getAllCompanyFactor} showModalData={{}} />
    </Context.CompanyFactorScreen.Provider>
  );
};

export default CompanyFactorsContainer;
